<div class="past-dispatches-container">
  @if (activeRouteName() === routesName.DISPATCH_PORTFOLIO) {
    <fdr-past-performance-ui-performance-interval></fdr-past-performance-ui-performance-interval>
    <fdr-past-performance-ui-dispatch-portfolio></fdr-past-performance-ui-dispatch-portfolio>
  } @else if (activeRouteName() === routesName.DISPATCH_SITE || activeRouteName() === routesName.EVENT_DETAILS) {
    <fdr-past-performance-ui-performance-interval></fdr-past-performance-ui-performance-interval>
  } @else {
    <fdr-past-performance-ui-past-dispatches-filters></fdr-past-performance-ui-past-dispatches-filters>
    <fdr-past-performance-ui-performance-overview></fdr-past-performance-ui-performance-overview>
    <fdr-past-performance-ui-performance-details [rows]="rowsSignal()"></fdr-past-performance-ui-performance-details>
  }
</div>
